import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { sharedCloneObject } from "../../../utils/shared-functions";

export const PAGE_ID = {
    DASHBOARD: '13b57268-62c9-11f1-a30f-42010a8e000b',
    GRUPO_CLIENTES: '13d02586-62c9-11f1-a30f-42010a8e000b',
    TIPO_CLIENTE: '13ea6615-62c9-11f1-a30f-42010a8e000b',
    CLIENTES: '140566a9-62c9-11f1-a30f-42010a8e000b',
    MAPA_CLIENTES: '142069a8-62c9-11f1-a30f-42010a8e000b',
    CONFIGURACION_CLIENTES: '143aa4ee-62c9-11f1-a30f-42010a8e000b',
    ALMACEN: '14557d9a-62c9-11f1-a30f-42010a8e000b',
    CATEGORIAS: '14705ad0-62c9-11f1-a30f-42010a8e000b',
    PRODUCTOS: '148b34f1-62c9-11f1-a30f-42010a8e000b',
    PAISES: '14a61380-62c9-11f1-a30f-42010a8e000b',
    CIUDADES: '14c0e83e-62c9-11f1-a30f-42010a8e000b',
    VENDEDORES: '14dbf3c5-62c9-11f1-a30f-42010a8e000b',
    ESTADOS: '14f6cc9b-62c9-11f1-a30f-42010a8e000b',
    ESTADO_DE_PAGO: '1511ab67-62c9-11f1-a30f-42010a8e000b',
    QUIEN_RECIBE_ENTREGA: '152c9604-62c9-11f1-a30f-42010a8e000b',
    FORMULARIO: '154760d0-62c9-11f1-a30f-42010a8e000b',
    GRUPO_GEOCERCA: '15624e2e-62c9-11f1-a30f-42010a8e000b',
    PROGRESS_BAR: '157d3b5f-62c9-11f1-a30f-42010a8e000b',
    PERSONA: '1599938e-62c9-11f1-a30f-42010a8e000b',
    ASIGNACION_PRINCIPAL: '15b4a0ed-62c9-11f1-a30f-42010a8e000b',
    ASIGNACION: '15cf7af9-62c9-11f1-a30f-42010a8e000b',
    ASIGNACION_CONFIGURACION: '15ea54bb-62c9-11f1-a30f-42010a8e000b',
    SEGUIMIENTO_MAPA: '16053241-62c9-11f1-a30f-42010a8e000b',
    SEGUIMIENTO_GRILLA: '16201551-62c9-11f1-a30f-42010a8e000b',
    ESTADO_INCIDENTE: '163b3231-62c9-11f1-a30f-42010a8e000b',
    LISTA_INCIDENTE: '16560de8-62c9-11f1-a30f-42010a8e000b',
    GESTIONAR_ESTADO_VIAJE: '1670e8bc-62c9-11f1-a30f-42010a8e000b',
    LISTA_VIAJES: '168b4c93-62c9-11f1-a30f-42010a8e000b',
    USUARIOS_WEB: '16a78fa6-62c9-11f1-a30f-42010a8e000b',
    USUARIOS_MOVIL: '16c28966-62c9-11f1-a30f-42010a8e000b',
    ROL_USUARIO_WEB: '16dd8d00-62c9-11f1-a30f-42010a8e000b',
    TIPO_USUARIO_MOVIL: '16f88c94-62c9-11f1-a30f-42010a8e000b',
    REPORTE_ESTADO_ENTREGAS: '1713693a-62c9-11f1-a30f-42010a8e000b',
    REPORTE_RESUMEN_ENTREGAS: '172e49ca-62c9-11f1-a30f-42010a8e000b',
    TIPO_CARGUIO: 'f335e54d-710f-11f1-a30f-42010a8e000b',
    KANBAN: 'ad9635ac-7116-11f1-a30f-42010a8e000b',
    LISTA_ESTADO_VEHICULO: '43e6087e-767f-11f1-a30f-42010a8e000b',
    LISTA_EJES_VEHICULO: '02025235-7686-11f1-a30f-42010a8e000b',
    TIPO_CHOFER: 'd4c0c508-78c3-11f1-a30f-42010a8e000b',
    REQUERIMIENTO_VIAJE: '821f223d-791c-11f1-a30f-42010a8e000b',
    FORMULARIO_VIAJE: "d624c152-78cc-11f1-a30f-42010a8e000b",
    GESTIONAR_TRANSPORTADORA: '48188776-7a10-11f1-a30f-42010a8e000b',
    PROGRAMACION_CAMIONES: '43ece64e-7c11-11f1-a30f-42010a8e000b',
    GESTIONAR_RESPUESTA_SOLICITUD_PROGRAMACION_CAMIONES: 'd71dc554-7c78-11f1-a30f-42010a8e000b',
    GESTIONAR_PRIORIDAD_ENTREGA: 'd82cabcc-832d-11f1-a30f-42010a8e000b',
    GESTIONAR_SOLICITUD_PRODUCTO: 'f4bc470e-832d-11f1-a30f-42010a8e000b',
    GESTIONAR_PROGRAMACION_SOLICITUD_PRODUCTO: "93a77f29-83fe-11f1-a30f-42010a8e000b",
    KANBAN_VIAJE: 'a1b2c3d4-8500-11f1-a30f-42010a8e000b',
    KANBAN_PRODUCTO: 'a1b2c3d5-8500-11f1-a30f-42010a8e000b',
    GESTIONAR_PROGRAMACION_CAMIONES_KANBAN: 'a1b2c3d6-8500-11f1-a30f-42010a8e000b',
    GESTIONAR_PROGRAMACION_PRODUCTOS_KANBAN: 'a1b2c3d7-8500-11f1-a30f-42010a8e000b',
};

const mergeAcciones = (templateAcciones, savedAcciones) => {
    if (!Array.isArray(templateAcciones)) return templateAcciones ?? [];
    const savedMap = new Map(
        (Array.isArray(savedAcciones) ? savedAcciones : []).map((a) => [a.value, a])
    );
    return templateAcciones.map((accion) => {
        const saved = savedMap.get(accion.value);
        return {
            ...accion,
            checked: saved?.checked ?? false,
        };
    });
};

const mergePagina = (templatePage, savedPage) => ({
    ...templatePage,
    checked: savedPage?.checked ?? false,
    acciones: mergeAcciones(templatePage.acciones, savedPage?.acciones),
});

/** Template is source of truth for structure/labels; saved data preserves checked states by id/value. */
export const mergePermisosPages = (template, saved) => {
    if (!Array.isArray(template)) return [];
    if (!Array.isArray(saved) || saved.length === 0) {
        return sharedCloneObject(template);
    }

    const savedByMenuId = new Map(saved.map((m) => [m.id, m]));

    return template.map((menu) => {
        const savedMenu = savedByMenuId.get(menu.id);

        if (menu.subMenu === null) {
            return mergePagina(menu, savedMenu);
        }

        if (Array.isArray(menu.subMenu)) {
            const savedSubMap = new Map(
                (savedMenu?.subMenu ?? []).map((p) => [p.value, p])
            );
            return {
                ...menu,
                checked: savedMenu?.checked ?? false,
                subMenu: menu.subMenu.map((subPage) =>
                    mergePagina(subPage, savedSubMap.get(subPage.value))
                ),
            };
        }

        return sharedCloneObject(menu);
    });
};

export const usePages = () => {
    const { t, i18n } = useTranslation();
    return useMemo(() => [
        {
            id: 1,
            checked: false,
            value: PAGE_ID.DASHBOARD,
            label: t('menu_dashboard'),
            subMenu: null,
            acciones: [
                {
                    value: 'btn_agregar',
                    label: t('btn_agregar'),
                    checked: false,
                },
                {
                    value: 'btn_guardar',
                    label: t('btn_guardar'),
                    checked: false,
                },
                {
                    value: 'btn_buscar',
                    label: t('btn_buscar'),
                    checked: false,
                },
                {
                    value: 'btn_eliminar',
                    label: t('btn_eliminar'),
                    checked: false,
                },
            ],
        },
        {
            id: 2,
            checked: false,
            label: t('menu_gestionar_clientes'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.GRUPO_CLIENTES,
                    label: t('menu_grupo_clientes'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.TIPO_CLIENTE,
                    label: t('menu_tipo_cliente'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.CLIENTES,
                    label: t('menu_clientes'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_importar',
                            label: t('btn_importar'),
                            checked: false,
                        },
                        {
                            value: 'btn_exportar',
                            label: t('btn_exportar'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.MAPA_CLIENTES,
                    label: t('menu_mapa_clientes'),
                    acciones: [

                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.CONFIGURACION_CLIENTES,
                    label: t('menu_configuracion_clientes'),
                    acciones: [
                        {
                            value: 'btn_importar',
                            label: t('btn_importar'),
                            checked: false,
                        },
                        {
                            value: 'btn_aceptar',
                            label: t('btn_aceptar'),
                            checked: false,
                        },
                        {
                            value: 'btn_cancelar',
                            label: t('btn_cancelar'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 3,
            checked: false,
            // value: PAGE_ID.ALMACEN,
            label: t('menu_almacen'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.ALMACEN,
                    label: t('menu_almacen'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 4,
            checked: false,
            label: t('menu_administracion'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.CATEGORIAS,
                    label: t('menu_categorias'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.PRODUCTOS,
                    label: t('menu_productos'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.PAISES,
                    label: t('menu_paises'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.CIUDADES,
                    label: t('menu_ciudades'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.VENDEDORES,
                    label: t('menu_vendedores'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.ESTADOS,
                    label: t('menu_estados'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_sub_estados',
                            label: t('btn_sub_estados'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.ESTADO_DE_PAGO,
                    label: t('menu_estado_de_pago'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.LISTA_ESTADO_VEHICULO,
                    label: t('menu_lista_estado_vehiculo'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.LISTA_EJES_VEHICULO,
                    label: t('menu_lista_ejes_vehiculo'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.QUIEN_RECIBE_ENTREGA,
                    label: t('menu_quien_recibe_entrega'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.FORMULARIO,
                    label: t('menu_formulario'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_default',
                            label: t('btn_default'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.GRUPO_GEOCERCA,
                    label: t('menu_grupo_geocerca'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.PROGRESS_BAR,
                    label: t('menu_progress_bar'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.PERSONA,
                    label: t('menu_persona'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },

                {
                    checked: false,
                    value: PAGE_ID.TIPO_CHOFER,
                    label: t('menu_tipo_chofer'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                // {
                //     checked: false,
                //     value: PAGE_ID.REQUERIMIENTO_VIAJE,
                //     label: t('menu_requerimiento_viaje'),
                //     acciones: [
                //         {
                //             value: 'btn_nuevo',
                //             label: t('btn_nuevo'),
                //             checked: false,
                //         },
                //         {
                //             value: 'btn_buscar',
                //             label: t('btn_buscar'),
                //             checked: false,
                //         },
                //         {
                //             value: 'btn_modificar',
                //             label: t('btn_modificar'),
                //             checked: false,
                //         },
                //         {
                //             value: 'btn_deshabilitar',
                //             label: t('btn_deshabilitar'),
                //             checked: false,
                //         },
                //         {
                //             value: 'btn_habilitar',
                //             label: t('btn_habilitar'),
                //             checked: false,
                //         },
                //     ],
                // },
                {
                    checked: false,
                    value: PAGE_ID.GESTIONAR_PRIORIDAD_ENTREGA,
                    label: t('menu_prioridad_entrega'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 5,
            checked: false,
            label: t('menu_asignacion'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.ASIGNACION_PRINCIPAL,
                    label: t('menu_asignacion_principal'),
                    acciones: [
                        {
                            value: 'btn_importar',
                            label: t('btn_importar'),
                            checked: false,
                        },
                        {
                            value: 'btn_exportar',
                            label: t('btn_exportar'),
                            checked: false,
                        },
                        {
                            value: 'btn_configuracion',
                            label: t('btn_configuracion'),
                            checked: false,
                        },
                        {
                            value: 'btn_limpiar',
                            label: t('btn_limpiar'),
                            checked: false,
                        },
                        {
                            value: 'btn_aceptar',
                            label: t('btn_aceptar'),
                            checked: false,
                        },
                        {
                            value: 'btn_eliminar',
                            label: t('btn_eliminar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.ASIGNACION,
                    label: t('menu_asignacion'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_eliminar_pedido',
                            label: t('btn_eliminar_pedido'),
                            checked: false,
                        },
                        {
                            value: 'btn_detalles_pedido',
                            label: t('btn_detalles_pedido'),
                            checked: false,
                        },
                        {
                            value: 'btn_eliminar_detalle_pedido',
                            label: t('btn_eliminar_detalle_pedido'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.ASIGNACION_CONFIGURACION,
                    label: t('menu_asignacion_configuracion'),
                    acciones: [
                        {
                            value: 'btn_importar',
                            label: t('btn_importar'),
                            checked: false,
                        },
                        {
                            value: 'btn_aceptar',
                            label: t('btn_aceptar'),
                            checked: false,
                        },
                        {
                            value: 'btn_cancelar',
                            label: t('btn_cancelar'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 6,
            checked: false,
            label: t('menu_seguimiento'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.SEGUIMIENTO_MAPA,
                    label: t('menu_seguimiento_mapa'),
                    acciones: [
                        {
                            value: 'btn_configuracion_placa',
                            label: t('btn_configuracion_placa'),
                            checked: false,
                        },
                        {
                            value: 'btn_filtros',
                            label: t('btn_filtros'),
                            checked: false,
                        },
                        {
                            value: 'btn_configuracion_pedido',
                            label: t('btn_configuracion_pedido'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.SEGUIMIENTO_GRILLA,
                    label: t('menu_seguimiento_grilla'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_productos',
                            label: t('btn_productos'),
                            checked: false,
                        },
                        {
                            value: 'btn_workflow',
                            label: t('btn_workflow'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 7,
            checked: false,
            label: t('menu_incidente'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.ESTADO_INCIDENTE,
                    label: t('menu_estado_incidente'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_sub_estados',
                            label: t('btn_sub_estados'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.LISTA_INCIDENTE,
                    label: t('menu_lista_incidentes'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_ver',
                            label: t('btn_ver'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 8,
            checked: false,
            label: t('menu_viaje'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.GESTIONAR_TRANSPORTADORA,
                    label: t('menu_gestionar_transportadora_sindicato'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.FORMULARIO_VIAJE,
                    label: t('menu_formulario_viaje'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.GESTIONAR_ESTADO_VIAJE,
                    label: t('menu_estado_viajes'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.TIPO_CARGUIO,
                    label: t('menu_tipo_carguio'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.KANBAN,
                    label: t('menu_kanban'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_acciones',
                            label: t('btn_acciones'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.KANBAN_VIAJE,
                    label: t('menu_kanban_viaje'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_acciones',
                            label: t('btn_acciones'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.KANBAN_PRODUCTO,
                    label: t('menu_kanban_producto'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_acciones',
                            label: t('btn_acciones'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.LISTA_VIAJES,
                    label: t('menu_lista_viajes'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.PROGRAMACION_CAMIONES,
                    label: t('menu_formulario_programacion_camiones'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_exportar',
                            label: t('btn_exportar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.GESTIONAR_RESPUESTA_SOLICITUD_PROGRAMACION_CAMIONES,
                    label: t('menu_respuesta_solicitud_programacion_camiones'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.GESTIONAR_PROGRAMACION_SOLICITUD_PRODUCTO,
                    label: t('menu_programacion_solicitud_productos'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.GESTIONAR_PROGRAMACION_CAMIONES_KANBAN,
                    label: t('menu_programacion_camiones_kanban'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_guardar',
                            label: t('btn_guardar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.GESTIONAR_PROGRAMACION_PRODUCTOS_KANBAN,
                    label: t('menu_programacion_productos_kanban'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_guardar',
                            label: t('btn_guardar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.GESTIONAR_SOLICITUD_PRODUCTO,
                    label: t('menu_solicitud_producto'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 9,
            checked: false,
            label: t('menu_usuarios'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.USUARIOS_WEB,
                    label: t('menu_usuarios_web'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_reset_password',
                            label: t('btn_reset_password'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.USUARIOS_MOVIL,
                    label: t('menu_usuarios_movil'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.ROL_USUARIO_WEB,
                    label: t('menu_rol_usuario_web'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_permisos',
                            label: t('btn_permisos'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.TIPO_USUARIO_MOVIL,
                    label: t('menu_tipo_usuario_movil'),
                    acciones: [
                        {
                            value: 'btn_nuevo',
                            label: t('btn_nuevo'),
                            checked: false,
                        },
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_modificar',
                            label: t('btn_modificar'),
                            checked: false,
                        },
                        {
                            value: 'btn_deshabilitar',
                            label: t('btn_deshabilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_habilitar',
                            label: t('btn_habilitar'),
                            checked: false,
                        },
                        {
                            value: 'btn_permisos',
                            label: t('btn_permisos'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
        {
            id: 10,
            checked: false,
            label: t('menu_reportes'),
            subMenu: [
                {
                    checked: false,
                    value: PAGE_ID.REPORTE_ESTADO_ENTREGAS,
                    label: t('menu_reporte_estado_entregas'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                    ],
                },
                {
                    checked: false,
                    value: PAGE_ID.REPORTE_RESUMEN_ENTREGAS,
                    label: t('menu_reporte_resumen_entregas'),
                    acciones: [
                        {
                            value: 'btn_buscar',
                            label: t('btn_buscar'),
                            checked: false,
                        },
                        {
                            value: 'btn_exportar',
                            label: t('btn_exportar'),
                            checked: false,
                        },
                    ],
                },
            ],
        },
    ], [i18n.language]);
};